<script>
import StoreSearchForm from '@maison/components/store/StoreSearchForm';
import Store from '@phoenix/components/Store';
import StoreSearchResultsTabMap from '@phoenix/mixins/components/store/StoreSearchResultsTabMap';
import { PhxStoreLocator } from '@phx-styleguides/jlc';

export default {
  components: {
    PhxStoreLocator,
    StoreSearchForm,
  },

  mixins: [StoreSearchResultsTabMap],

  props: {
    isSuggestionActivated: {
      type: Boolean,
      default: false,
    },
    allStoresUrl: {
      type: String,
      default: '',
    },
    storeServices: {
      type: Array,
      default: () => [],
    },
  },

  emits: ['geolocation', 'query', 'change'],

  data: () => ({
    selectedStoreServices: [],
  }),

  computed: {
    getStores() {
      const stores = this.stores.length ? this.stores : this.allStores;

      return stores
        .map((store) => {
          if (this.selectedStoreServices.length > 0) {
            const numberOfIntersectedServices = store.services
              .map((service) => service)
              .filter((service) => this.selectedStoreServices.includes(service)).length;
            if (numberOfIntersectedServices === 0) {
              return null;
            }
          }

          const status = (() => {
            const storeStatus = new Store(
              store.openingHours,
              store.specialDays,
              store.timezone,
              store.isOnline,
              store.id,
            ).getStatus();

            const isOpen = storeStatus.status === 'open';

            return {
              open: isOpen,
              text: this.$t(isOpen ? 'Store.openStatus' : 'Store.closedStatus'),
            };
          })();

          let pretitle = this.$t('Store.boutique');
          let pretitleClass = '';

          if (store.isRepairer) {
            pretitle = this.$t('Store.repairer');
            pretitleClass = 'boutique-card__pretitle--discrete';
          } else if (store.isReseller) {
            pretitle = this.$t('Store.reseller');
            pretitleClass = 'boutique-card__pretitle--discrete';
          }

          const title = store.name;

          return {
            ...store,
            services: store.inlineServices ? store.inlineServices.split(' - ') : [],
            status,
            pretitle,
            pretitleClass,
            title,
          };
        })
        .filter((store) => store !== null);
    },
  },

  methods: {
    onGeolocation() {
      this.$emit('geolocation');
    },

    onQuery(value) {
      this.$emit('query', value);
    },

    onChange(value) {
      this.$emit('change', value);
    },

    onLocationSelect(location) {
      if (!location.permalink) {
        return;
      }

      window.open(location.permalink, '_self');
    },
  },
};
</script>

<template>
  <phx-store-locator
    ref="storeLocator"
    v-model:selected-filters="selectedStoreServices"
    :api-key="apiKey"
    :map-id="mapId"
    :engine="engine"
    :center="center"
    :zoom="zoom"
    :geolocation="position"
    :fit-bounds="fitBounds"
    :locations="getStores"
    :region="region"
    :search-label="$t('StoreSearch.title')"
    :load-more-button-label="$t('Button.LoadMore')"
    :see-all-boutiques-link-label="$t('StoreSearch.seeAllStores')"
    :see-all-boutiques-link-url="allStoresUrl"
    :no-result-text="$t('StoreSearch.noResults')"
    :filters="storeServices"
    :filters-label="$t('StoreSearch.filterByService')"
    :filters-placeholder="$t('StoreSearch.filterByServicePlaceholder')"
    @map:initialized="onMapInitialized"
    @map:bounds:changed="onMapBoundsChanged"
    @location:select="onLocationSelect"
  >
    <template #autocomplete>
      <store-search-form
        :is-suggestion-activated="isSuggestionActivated"
        @query="onQuery"
        @change="onChange"
        @geolocation="onGeolocation"
      />
    </template>
  </phx-store-locator>
</template>
